exports = module.exports = require("../../../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#kpi-section {\n  height: calc(100% - 0%); }\n  #kpi-section mat-tab-group {\n    height: 100%; }\n  #kpi-section mat-tab-group .mat-tab-label {\n      text-transform: uppercase;\n      color: white !important;\n      opacity: 1 !important;\n      font-size: 16px; }\n  #kpi-section mat-tab-group .mat-tab-body-wrapper {\n      height: 100% !important;\n      -webkit-box-flex: 1;\n          -ms-flex-positive: 1;\n              flex-grow: 1; }\n  #kpi-section mat-tab-group .mat-tab-body-wrapper .mat-tab-body {\n        height: 100% !important; }\n  #kpi-section mat-tab-group .mat-tab-body-wrapper .mat-tab-body .mat-tab-body-content {\n          height: 100% !important; }\n  #kpi-section .mat-tab-group.mat-accent .mat-ink-bar, #kpi-section .mat-tab-nav-bar.mat-accent .mat-ink-bar {\n    background-color: #039be5;\n    height: 3px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/kpi/kpi.component.scss
// module id = ../../../../../src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/kpi/kpi.component.scss
// module chunks = main